<div class="x-section__headline">
	<h2 class="mat-h1">Kontakte</h2>
</div>
<schir-int-client-kontakt-search-field
		#searchField
		class="searchfield"
		(doSearch)="doSearch($event)"
		(confirmSearch)="doConfirmUpdate()"
		[searchParameters]="searchParameters"
		(toggleKontaktDarstellung)="toggleKontaktDarstellung()"/>

@if (isNewKontakt()) {
	<div class="new-kontakt" data-test-id="new-kontakt" tabindex="0">
		<mat-icon class="kontakt-icon">add_circle</mat-icon>
		<p>Neuer Kontakt</p>
	</div>
}

<div id="scroll-area" class="scroll-area">
	<ul #scrollArea class="c-list">
		@for (kontakt of kontakte; track getUrl(kontakt)) {
			<div #kontaktList [id]="$index+'k'" [attr.data-self-link]="getUrl(kontakt)">
				@if (newGroupLetter(kontakt)) {
					<p class="group-separator">{{ groupChar }}</p>
				}
				<div class="relative-container">
					<li
							#kontaktDiv
							class="kontakt-entry"
							data-test-id="kontakt-entry"
							[attr.data-title]="kontakt.title"
							[attr.id]="$index+'k'"
							(click)="patchKontakt(kontakt)"
							(keyup.enter)="patchKontaktAndFocus(kontakt)"
							tabindex="0"
							[ngClass]="isSelectedKontakt(kontakt) ? 'focused' : ''">
						<div [ngStyle]="!kontakt.active && {'color': 'lightgray'}">
							<mat-icon class="kontakt-icon">{{kontakt.juristischePerson ? 'business' : 'person' }}</mat-icon>
							<span class="kontakt-name" data-test-id="kontakt-name">{{ kontakt.title }}</span>
							@if (showAddress) {
								<div>
									<span class="kontakt-adresse" data-test-id="kontakt-adresse">{{ kontakt.strasse }}&nbsp;{{ kontakt.hausnummer }}, {{ kontakt.plz }}&nbsp;{{ kontakt.stadt }} </span>
								</div>
							}
						</div>
						@if (hasLink(kontakt, KontaktLinkRel.EDIT)) {
							<schir-int-client-button-round
									id="assign-button"
									class="assign-button"
									data-test-id="assign-button"
									toolTip="Rolle zuweisen"
									materialIcon="switch_account"
									cssClass="focus-inwards-dark"
									(click)="openAssignMenu(kontakt, kontaktDiv, scrollArea)"/>
						}
						<schir-int-client-button-round
								id="mail-address-button"
								class="mail-address-button"
								data-test-id="mail-address-button"
								toolTip="Adressdaten in die Zwischenablage kopieren"
								materialIcon="contact_mail"
								cssClass="focus-inwards-dark"
								(click)="copyMailAddressToClipboard(kontakt)"/>
					</li>
				</div>
			</div>
		}
		<div class="visually-hidden" aria-hidden="true" data-test-id="number-listed-contacts">{{kontakte.length}}</div>
		@if (tooManyResults) {
			<div class="expect_more">Es können nicht alle Ergebnisse angezeigt werden. Bitte konkretisieren Sie die Suchanfrage!</div>
		}
	</ul>
	<span class="visually-hidden" role="alert">{{ audioAlert | async }}</span>
</div>

@if (!editMode && allowWriteAccess) {
	<schir-int-client-button-round
			class="add-button"
			data-test-id="hinzufuegen-button"
			toolTip="Kontakt hinzufügen"
			materialIcon="person_add"
			(click)="patchNewKontakt(); searchField.clearSearchField()"
			cssClass="focus-inwards-dark"/>
}
